import { TypographyProps } from '@mui/material'
import { Typography } from 'components/Material/index'

interface DisplayTextProps extends TypographyProps {
  text: string | number
  typeStyle: 'large'
}

export const DisplayText: React.FC<DisplayTextProps> = ({ text, typeStyle, ...props }) => {
  return (
    <Typography {...props} sx={styles[typeStyle]}>
      {text}
    </Typography>
  )
}

const styles = {
  large: {
    fontSize: '57px',
    lineHeight: '64px',
    fontFamily: 'BB-Font-Bold'
  }
}
